// extracted by css-extract-rspack-plugin
export default {"linkContainer":"link-container--gECElq9ojg02Ln92"};